import CustomCheckbox from '../../../../../components/Inputs/Checkbox/CustomCheckbox';
import { MdArrowRight } from "react-icons/md";
import { FilterOptionItemProps } from '../types';

// Tope para el escalonado
const MAX_STAGGER_ITEMS = 10;
const STAGGER_MS = 20;

const FilterOptionItem = ({ option, idPrefix, isSelected, index, onSelect, showArrow = true, bgSelected = true }: FilterOptionItemProps) => (
    <li
        className={`py-3 px-4 border-l-4 flex items-center justify-between transition-colors duration-200 ease-in-out animate-slide-fade-in [animation-fill-mode:both] ${isSelected && bgSelected ? 'border-brand-green-20 bg-brand-green-5' : 'border-transparent'}`}
        style={{ animationDelay: `${Math.min(index, MAX_STAGGER_ITEMS) * STAGGER_MS}ms` }}
    >
        <CustomCheckbox
            id={`${idPrefix}-${option.id}`}
            name={option.label}
            label={option.label}
            checked={isSelected}
            onChange={() => onSelect(option)}
        />
        {
            showArrow && (isSelected ? <MdArrowRight size={18} className='shrink-0' /> : <div className='h-[18px] w-[18px]'></div>)
        }
    </li>
);

export default FilterOptionItem;
